export enum DropWeightUnit {
  G = 'g',
  Oz = 'oz',
}
